import { useCallback } from 'react';
import downloadCsv from '@dyl/utils/downloadAssetCsv';

/** @type {import('@dyl/utils/downloadCsv').CsvColumn[]} */
const Columns = [
    { label: 'Asset ID', key: 'asset_id' },
    { label: 'Updated At', key: 'updated_at' },
    { label: 'Task ID', key: 'task_ids' },
];

export default function useAssetsDownload() {
    return useCallback(
        /**
         * @param {{
         *  image_id: string
         *  updated_at: string | null
         *  task_ids: array
         * }[]} assets
         */
        function downloadAssetsCsv(assets) {

            const fileName = `GeneratedAssets_${new Date().toDateString()}.csv`;

            downloadCsv(fileName, Columns, assets);
        }, []
    );
}